module.exports = __webpack_public_path__ + "static/img/title.9332573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baoming2/title.png
// module id = TrYO
// module chunks = 1